"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link.js");
require("core-js/modules/es6.array.map.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _activityIndicator = _interopRequireDefault(require("@gravity/activity-indicator"));
var _skeleton = _interopRequireDefault(require("@gravity/skeleton"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _dialog = _interopRequireDefault(require("@gravity/dialog"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _popUp = _interopRequireDefault(require("@gravity/pop-up"));
var _section = require("@gravity/section");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _catalog = require("@nucleo/catalog");
var _resaleAvailability = require("@nucleo/resale-availability");
var _streamOnline = _interopRequireDefault(require("@nucleo/stream-online"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDeviceDetect = require("react-device-detect");
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _jsxFileName = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Catalog/lib/Catalog.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1i7mlmqhoh() {
  var path = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Catalog/lib/Catalog.js";
  var hash = "d56e959b48a85fe74f04801e1b3c84ab156cb832";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Catalog/lib/Catalog.js",
    statementMap: {
      "0": {
        start: {
          line: 28,
          column: 16
        },
        end: {
          line: 68,
          column: 1
        }
      },
      "1": {
        start: {
          line: 37,
          column: 35
        },
        end: {
          line: 37,
          column: 84
        }
      },
      "2": {
        start: {
          line: 70,
          column: 22
        },
        end: {
          line: 106,
          column: 1
        }
      },
      "3": {
        start: {
          line: 108,
          column: 22
        },
        end: {
          line: 130,
          column: 1
        }
      },
      "4": {
        start: {
          line: 132,
          column: 22
        },
        end: {
          line: 141,
          column: 1
        }
      },
      "5": {
        start: {
          line: 143,
          column: 20
        },
        end: {
          line: 149,
          column: 1
        }
      },
      "6": {
        start: {
          line: 151,
          column: 29
        },
        end: {
          line: 154,
          column: 1
        }
      },
      "7": {
        start: {
          line: 156,
          column: 28
        },
        end: {
          line: 179,
          column: 1
        }
      },
      "8": {
        start: {
          line: 181,
          column: 38
        },
        end: {
          line: 195,
          column: 1
        }
      },
      "9": {
        start: {
          line: 197,
          column: 25
        },
        end: {
          line: 245,
          column: 1
        }
      },
      "10": {
        start: {
          line: 198,
          column: 2
        },
        end: {
          line: 211,
          column: 3
        }
      },
      "11": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 210,
          column: 6
        }
      },
      "12": {
        start: {
          line: 203,
          column: 25
        },
        end: {
          line: 203,
          column: 66
        }
      },
      "13": {
        start: {
          line: 212,
          column: 2
        },
        end: {
          line: 244,
          column: 4
        }
      },
      "14": {
        start: {
          line: 216,
          column: 23
        },
        end: {
          line: 216,
          column: 64
        }
      },
      "15": {
        start: {
          line: 233,
          column: 27
        },
        end: {
          line: 233,
          column: 68
        }
      },
      "16": {
        start: {
          line: 247,
          column: 16
        },
        end: {
          line: 311,
          column: 1
        }
      },
      "17": {
        start: {
          line: 267,
          column: 2
        },
        end: {
          line: 310,
          column: 12
        }
      },
      "18": {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 282,
          column: 8
        }
      },
      "19": {
        start: {
          line: 313,
          column: 0
        },
        end: {
          line: 346,
          column: 2
        }
      },
      "20": {
        start: {
          line: 348,
          column: 0
        },
        end: {
          line: 368,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 20
          },
          end: {
            line: 37,
            column: 21
          }
        },
        loc: {
          start: {
            line: 37,
            column: 35
          },
          end: {
            line: 37,
            column: 84
          }
        },
        line: 37
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 197,
            column: 25
          },
          end: {
            line: 197,
            column: 26
          }
        },
        loc: {
          start: {
            line: 197,
            column: 79
          },
          end: {
            line: 245,
            column: 1
          }
        },
        line: 197
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 203,
            column: 19
          },
          end: {
            line: 203,
            column: 20
          }
        },
        loc: {
          start: {
            line: 203,
            column: 25
          },
          end: {
            line: 203,
            column: 66
          }
        },
        line: 203
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 216,
            column: 17
          },
          end: {
            line: 216,
            column: 18
          }
        },
        loc: {
          start: {
            line: 216,
            column: 23
          },
          end: {
            line: 216,
            column: 64
          }
        },
        line: 216
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 233,
            column: 21
          },
          end: {
            line: 233,
            column: 22
          }
        },
        loc: {
          start: {
            line: 233,
            column: 27
          },
          end: {
            line: 233,
            column: 68
          }
        },
        line: 233
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 247,
            column: 16
          },
          end: {
            line: 247,
            column: 17
          }
        },
        loc: {
          start: {
            line: 267,
            column: 2
          },
          end: {
            line: 310,
            column: 12
          }
        },
        line: 267
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 268,
            column: 27
          },
          end: {
            line: 268,
            column: 28
          }
        },
        loc: {
          start: {
            line: 269,
            column: 6
          },
          end: {
            line: 282,
            column: 8
          }
        },
        line: 269
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 35
          },
          end: {
            line: 37,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 35
          },
          end: {
            line: 37,
            column: 55
          }
        }, {
          start: {
            line: 37,
            column: 59
          },
          end: {
            line: 37,
            column: 84
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 53,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 46,
            column: 18
          }
        }, {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 53,
            column: 9
          }
        }],
        line: 46
      },
      "2": {
        loc: {
          start: {
            line: 198,
            column: 2
          },
          end: {
            line: 211,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 198,
            column: 2
          },
          end: {
            line: 211,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 198
      },
      "3": {
        loc: {
          start: {
            line: 284,
            column: 5
          },
          end: {
            line: 302,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 284,
            column: 5
          },
          end: {
            line: 284,
            column: 21
          }
        }, {
          start: {
            line: 285,
            column: 6
          },
          end: {
            line: 301,
            column: 22
          }
        }],
        line: 284
      },
      "4": {
        loc: {
          start: {
            line: 286,
            column: 9
          },
          end: {
            line: 300,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 286,
            column: 10
          },
          end: {
            line: 286,
            column: 18
          }
        }, {
          start: {
            line: 287,
            column: 10
          },
          end: {
            line: 292,
            column: 19
          }
        }, {
          start: {
            line: 294,
            column: 10
          },
          end: {
            line: 299,
            column: 19
          }
        }],
        line: 286
      },
      "5": {
        loc: {
          start: {
            line: 290,
            column: 24
          },
          end: {
            line: 290,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 290,
            column: 24
          },
          end: {
            line: 290,
            column: 28
          }
        }, {
          start: {
            line: 290,
            column: 32
          },
          end: {
            line: 290,
            column: 92
          }
        }],
        line: 290
      },
      "6": {
        loc: {
          start: {
            line: 297,
            column: 24
          },
          end: {
            line: 297,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 297,
            column: 24
          },
          end: {
            line: 297,
            column: 28
          }
        }, {
          start: {
            line: 297,
            column: 32
          },
          end: {
            line: 297,
            column: 92
          }
        }],
        line: 297
      },
      "7": {
        loc: {
          start: {
            line: 303,
            column: 5
          },
          end: {
            line: 309,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 303,
            column: 5
          },
          end: {
            line: 303,
            column: 17
          }
        }, {
          start: {
            line: 304,
            column: 6
          },
          end: {
            line: 308,
            column: 15
          }
        }],
        line: 303
      },
      "8": {
        loc: {
          start: {
            line: 304,
            column: 20
          },
          end: {
            line: 304,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 304,
            column: 20
          },
          end: {
            line: 304,
            column: 45
          }
        }, {
          start: {
            line: 304,
            column: 49
          },
          end: {
            line: 304,
            column: 69
          }
        }],
        line: 304
      },
      "9": {
        loc: {
          start: {
            line: 305,
            column: 9
          },
          end: {
            line: 307,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 305,
            column: 10
          },
          end: {
            line: 305,
            column: 30
          }
        }, {
          start: {
            line: 305,
            column: 34
          },
          end: {
            line: 305,
            column: 56
          }
        }, {
          start: {
            line: 305,
            column: 60
          },
          end: {
            line: 305,
            column: 72
          }
        }, {
          start: {
            line: 306,
            column: 11
          },
          end: {
            line: 306,
            column: 31
          }
        }, {
          start: {
            line: 306,
            column: 35
          },
          end: {
            line: 306,
            column: 59
          }
        }, {
          start: {
            line: 306,
            column: 63
          },
          end: {
            line: 306,
            column: 84
          }
        }, {
          start: {
            line: 307,
            column: 10
          },
          end: {
            line: 307,
            column: 76
          }
        }],
        line: 305
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d56e959b48a85fe74f04801e1b3c84ab156cb832"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1i7mlmqhoh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1i7mlmqhoh();
var Wrapper = (cov_1i7mlmqhoh().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'stx-Catalog'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      padding: 0 2rem;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      background: ", ";\n      max-width: ", ";\n      padding: ", ";\n      box-shadow: none;\n\n      > .stx-Section:not(:first-child) {\n        margin-top: ", "px;\n      }\n\n      ", ";\n\n      ", ";\n\n      ", ";\n    "])), function (_ref) {
  var theme = _ref.theme;
  cov_1i7mlmqhoh().f[0]++;
  cov_1i7mlmqhoh().s[1]++;
  return (cov_1i7mlmqhoh().b[0][0]++, theme.contentBgColor) || (cov_1i7mlmqhoh().b[0][1]++, _themeMapper.evolutionTheme.catalog.bg);
}, _themeMapper.evolutionTheme.catalog.maxWidth, _themeMapper.evolutionTheme.catalog.marginX, _themeMapper.evolutionTheme.spacings.xxl, (cov_1i7mlmqhoh().b[1][0]++, !_reactDeviceDetect.isDesktop) && (cov_1i7mlmqhoh().b[1][1]++, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n          > .stx-Section {\n            .g-FilmStrip-sliderContainer {\n              margin-right: -", ";\n            }\n          }\n        "])), _themeMapper.evolutionTheme.catalog.marginX)), _utils.gMediaQueries.lg(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n        margin-left: 0;\n        margin-right: 0;\n      "]))), _utils.gMediaQueries.sm(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n        ", ";\n        padding: ", ";\n        margin: ", " ", " 0 ", ";\n        border-radius: var(--generalBorderRadius, 12px);\n      "])), (0, _utils.boxShadowOf)('Section', {
  defaultValue: _themeMapper.evolutionTheme.catalog.boxShadow
}), _themeMapper.evolutionTheme.catalog.padding, _themeMapper.evolutionTheme.catalog.marginTop, _themeMapper.evolutionTheme.catalog.marginX, _themeMapper.evolutionTheme.catalog.marginX)))));
var ButtonWrapper = (cov_1i7mlmqhoh().s[2]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'stx-Catalog-seeAllButton'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      display: flex;\n      justify-content: space-around;\n      padding: ", " 0;\n    "])), _stylingConstants.default.spacing.xxlarge)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      padding: 0;\n      > a {\n        margin-top: ", "px;\n      }\n      &.stx-Catalog-seeAllButton button.g-Button-flat,\n      &.stx-Catalog-seeAllButton a.g-Button-flat {\n        color: var(--linkTextColor, white);\n      }\n      > button {\n        width: 100%;\n        margin-top: ", "px;\n        &.g-Button-flat:hover {\n          box-shadow: none;\n        }\n\n        ", ";\n      }\n    "])), _themeMapper.evolutionTheme.spacings.xl, _themeMapper.evolutionTheme.spacings.xl, _utils.gMediaQueries.sm(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n          max-width: min(25%, 200px);\n        "])))))));
var DialogWrapper = (cov_1i7mlmqhoh().s[3]++, _styledComponents.default.div.attrs({
  className: 'g-PopupWrapper'
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 400px;\n  margin-left: -200px;\n  ", ";\n  margin-top: -100px;\n  box-sizing: border-box;\n  height: auto;\n  background-color: #ffffff;\n  display: block;\n  justify-content: center;\n  .g-PopUp {\n    position: unset;\n    padding: 15px;\n  }\n"])), _stylingConstants.default.mediaQueries.tablet(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n    width: 600px;\n    margin-left: -300px;\n  "])))));
var HeaderWrapper = (cov_1i7mlmqhoh().s[4]++, _styledComponents.default.div.attrs({
  className: 'g-PopupHeader'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  background-color: #f8f8f8;\n  color: red;\n  display: flex;\n  height: 100px;\n  justify-content: center;\n  align-items: center;\n"]))));
var IconWrapper = (cov_1i7mlmqhoh().s[5]++, _styledComponents.default.div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  width: 20%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]))));
var HeaderContentWrapper = (cov_1i7mlmqhoh().s[6]++, _styledComponents.default.div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n  width: 80%;\n  font-size: 0.9rem;\n"]))));
var StreamOnlineWrapper = (cov_1i7mlmqhoh().s[7]++, _styledComponents.default.div.attrs({
  className: 'stx-Catalog-streamOnlineContainer'
})(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  width: 70%;\n  height: auto;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  .g-PopUp {\n    position: unset;\n    min-width: unset;\n    .iframe-Container {\n      position: relative;\n      width: auto;\n      height: 500px;\n      display: block;\n      iframe {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n"]))));
var StreamOnlineWarningBtnWrapper = (cov_1i7mlmqhoh().s[8]++, _styledComponents.default.div.attrs({
  className: 'stx-Catalog-streamOnlineBtnContainer'
})(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  button {\n    margin: 10px;\n    text-transform: uppercase;\n  }\n  a {\n    text-transform: uppercase;\n  }\n"]))));
cov_1i7mlmqhoh().s[9]++;
var getDialogContent = function getDialogContent(streamOnline, updateStreamOnlineDialogVisibility) {
  cov_1i7mlmqhoh().f[1]++;
  cov_1i7mlmqhoh().s[10]++;
  if (streamOnline.streamContentValue) {
    cov_1i7mlmqhoh().b[2][0]++;
    cov_1i7mlmqhoh().s[11]++;
    return /*#__PURE__*/_react.default.createElement(StreamOnlineWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 200,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement(_popUp.default, {
      visible: streamOnline.isShowDialog,
      onClose: function onClose() {
        cov_1i7mlmqhoh().f[2]++;
        cov_1i7mlmqhoh().s[12]++;
        return updateStreamOnlineDialogVisibility(false);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 201,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "iframe-Container",
      dangerouslySetInnerHTML: {
        __html: streamOnline.streamContentValue.link
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 204,
        columnNumber: 11
      }
    })));
  } else {
    cov_1i7mlmqhoh().b[2][1]++;
  }
  cov_1i7mlmqhoh().s[13]++;
  return /*#__PURE__*/_react.default.createElement(DialogWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_popUp.default, {
    visible: streamOnline.isShowDialog,
    onClose: function onClose() {
      cov_1i7mlmqhoh().f[3]++;
      cov_1i7mlmqhoh().s[14]++;
      return updateStreamOnlineDialogVisibility(false);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 217,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    size: 88,
    iconName: "warning",
    iconColor: "red",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 219,
      columnNumber: 13
    }
  })), /*#__PURE__*/_react.default.createElement(HeaderContentWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 221,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontWeight: 'bold'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 222,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "streamOnline.title.warning",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 15
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '5px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "streamOnline.label.warning",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 226,
      columnNumber: 15
    }
  })))), /*#__PURE__*/_react.default.createElement(StreamOnlineWarningBtnWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 230,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    flat: true,
    onClick: function onClick() {
      cov_1i7mlmqhoh().f[4]++;
      cov_1i7mlmqhoh().s[15]++;
      return updateStreamOnlineDialogVisibility(false);
    },
    style: {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    iconName: "chevron-left",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 235,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "streamOnline.button.cancel",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 236,
      columnNumber: 13
    }
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    href: streamOnline.dialogActionUrl,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 238,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "streamOnline.button.continueToBuy",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 239,
      columnNumber: 13
    }
  })))));
};
cov_1i7mlmqhoh().s[16]++;
var Catalog = function Catalog(_ref2) {
  var _catalog$sections;
  var catalog = _ref2.catalog,
    showSeeAllButton = _ref2.showSeeAllButton,
    seeAllButtonUrl = _ref2.seeAllButtonUrl,
    currencyCode = _ref2.currencyCode,
    waitingListEnabled = _ref2.waitingListEnabled,
    isSignedIn = _ref2.isSignedIn,
    onActionClick = _ref2.onActionClick,
    onSeeAll = _ref2.onSeeAll,
    isLandingPage = _ref2.isLandingPage,
    onWatchStreamOnline = _ref2.onWatchStreamOnline,
    streamOnline = _ref2.streamOnline,
    updateStreamOnlineDialogVisibility = _ref2.updateStreamOnlineDialogVisibility,
    ecommerceGoogleTracking = _ref2.ecommerceGoogleTracking,
    replaceProductNameByPerformance = _ref2.replaceProductNameByPerformance,
    resaleAvailability = _ref2.resaleAvailability,
    intl = _ref2.intl,
    themeQueries = _ref2.themeQueries,
    currentTheme = _ref2.currentTheme;
  cov_1i7mlmqhoh().f[5]++;
  cov_1i7mlmqhoh().s[17]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 267,
      columnNumber: 3
    }
  }, (_catalog$sections = catalog.sections) === null || _catalog$sections === void 0 ? void 0 : _catalog$sections.map(function (section) {
    cov_1i7mlmqhoh().f[6]++;
    cov_1i7mlmqhoh().s[18]++;
    return /*#__PURE__*/_react.default.createElement(_section.Section, {
      key: section.code,
      section: section,
      currencyCode: currencyCode,
      waitingListEnabled: waitingListEnabled,
      isSignedIn: isSignedIn,
      onActionClick: onActionClick,
      ecommerceGoogleTracking: ecommerceGoogleTracking,
      isLandingPage: isLandingPage,
      onWatchStreamOnline: onWatchStreamOnline,
      streamOnline: streamOnline,
      replaceProductNameByPerformance: replaceProductNameByPerformance,
      resaleAvailability: resaleAvailability,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 269,
        columnNumber: 7
      }
    });
  }), (cov_1i7mlmqhoh().b[3][0]++, showSeeAllButton) && (cov_1i7mlmqhoh().b[3][1]++, /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
    currentTheme: currentTheme,
    themeQueries: themeQueries,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 285,
      columnNumber: 7
    }
  }, (cov_1i7mlmqhoh().b[4][0]++, onSeeAll) && (cov_1i7mlmqhoh().b[4][1]++, /*#__PURE__*/_react.default.createElement(_button.default, {
    flat: themeQueries.EVOLUTION,
    onClick: onSeeAll,
    "aria-label": (cov_1i7mlmqhoh().b[5][0]++, intl) && (cov_1i7mlmqhoh().b[5][1]++, intl.formatMessage({
      id: 'gravity.Catalog.seeAll.altText'
    })),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 287,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Catalog.seeAll",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 291,
      columnNumber: 13
    }
  }))) || (cov_1i7mlmqhoh().b[4][2]++, /*#__PURE__*/_react.default.createElement(_button.default, {
    flat: themeQueries.EVOLUTION,
    href: seeAllButtonUrl,
    "aria-label": (cov_1i7mlmqhoh().b[6][0]++, intl) && (cov_1i7mlmqhoh().b[6][1]++, intl.formatMessage({
      id: 'gravity.Catalog.seeAll.altText'
    })),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 294,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Catalog.seeAll",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 298,
      columnNumber: 13
    }
  }))))), (cov_1i7mlmqhoh().b[7][0]++, streamOnline) && (cov_1i7mlmqhoh().b[7][1]++, /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: (cov_1i7mlmqhoh().b[8][0]++, streamOnline.isShowDialog) || (cov_1i7mlmqhoh().b[8][1]++, streamOnline.LOADING),
    backdrop: {
      opacity: 0.5
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 304,
      columnNumber: 7
    }
  }, (cov_1i7mlmqhoh().b[9][0]++, streamOnline.LOADING) && (cov_1i7mlmqhoh().b[9][1]++, themeQueries.EVOLUTION) && (cov_1i7mlmqhoh().b[9][2]++, /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 305,
      columnNumber: 61
    }
  })) || (cov_1i7mlmqhoh().b[9][3]++, streamOnline.LOADING) && (cov_1i7mlmqhoh().b[9][4]++, themeQueries.EQUILIBRIUM) && (cov_1i7mlmqhoh().b[9][5]++, /*#__PURE__*/_react.default.createElement(_activityIndicator.default, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 306,
      columnNumber: 64
    }
  })) || (cov_1i7mlmqhoh().b[9][6]++, getDialogContent(streamOnline, updateStreamOnlineDialogVisibility)))));
};
cov_1i7mlmqhoh().s[19]++;
Catalog.propTypes = {
  /* The catalog object, containing a list of sections */
  catalog: _catalog.CatalogType.isRequired,
  /* The resale availability object, containing information of resale availability */
  resaleAvailability: _resaleAvailability.ResaleAvailabilityType.isRequired,
  /* Boolean, indicating if the see all button pointing on whole list of products is displayed */
  showSeeAllButton: _propTypes.default.bool,
  /** Function to open the new gravity list of products instead of the old ticket-shop version */
  onSeeAll: _propTypes.default.func,
  /* URL that is called to show all products */
  seeAllButtonUrl: _propTypes.default.string,
  /* The needed currency to display prices */
  currencyCode: _propTypes.default.string,
  /* Define if waiting list for product not yet in sales is opened */
  waitingListEnabled: _propTypes.default.bool,
  /* Identify a user signed in or not */
  isSignedIn: _propTypes.default.bool,
  /** The function called when clicking on the product or occurence action */
  onActionClick: _propTypes.default.func,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Function to handle watch stream online */
  onWatchStreamOnline: _propTypes.default.func,
  /** Stream Online object, contain dialog state and stream content */
  streamOnline: _streamOnline.default,
  updateStreamOnlineDialogVisibility: _propTypes.default.func,
  replaceProductNameByPerformance: _propTypes.default.bool,
  intl: _reactIntl.intlShape.isRequired,
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string.isRequired
};
cov_1i7mlmqhoh().s[20]++;
Catalog.defaultProps = {
  showSeeAllButton: false,
  seeAllButtonUrl: null,
  onSeeAll: null,
  currencyCode: null,
  waitingListEnabled: false,
  isSignedIn: false,
  onActionClick: null,
  isLandingPage: false,
  onWatchStreamOnline: null,
  streamOnline: null,
  updateStreamOnlineDialogVisibility: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    userInfo: {},
    useGA4: false
  },
  replaceProductNameByPerformance: false,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {}
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _styledComponents.withTheme)((0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(Catalog))));